import { render, staticRenderFns } from "./info_docente.vue?vue&type=template&id=9fae4994"
import script from "./info_docente.vue?vue&type=script&lang=js"
export * from "./info_docente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports